export function copyText (text) {
  var str = typeof text === 'string' ? text : ''
  if (!str) {
    return Promise.reject(new Error('未找到要复制的内容！'))
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(str)
  }

  return new Promise(function (resolve, reject) {
    try {
      var textarea = document.createElement('textarea')
      textarea.value = str
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      resolve()
    } catch (e) {
      reject(e || new Error('复制失败'))
    }
  })
}

